/** The landing page (03 §0.3): local play, and sign-in; a signed-in user gets the way into the lobby instead. */
import { t } from '@tarock/i18n';
import { authStore } from '../stores/auth';
import { Footer } from './Footer';
import { SignupLink } from './SignupLink';

/** Signed in: the lobby; a guest: sign in, or sign up (03 §1.4). */
function AccountLine() {
  const user = authStore.user.value;
  if (authStore.status.value === 'unknown') {
    return null;
  }
  return user ? (
    <p data-testid="signed-in-as">
      <a class="btn primary" href="/lobby">
        {t('landing.openLobby')}
      </a>
    </p>
  ) : (
    <p>
      <a class="btn" href="/login">
        {t('nav.signIn')}
      </a>{' '}
      <SignupLink />
    </p>
  );
}

/** `/` */
export function Home() {
  const signedIn = authStore.user.value !== null;
  return (
    <main class="page" id="main" data-page="home">
      <section class="hero">
        <h1>tarock.game</h1>
        <p>{t('landing.title')}</p>
        {signedIn && <AccountLine />}
        <p>
          <a class={`btn${signedIn ? '' : ' primary'}`} href="/play/local">
            {t('landing.playLocal')}
          </a>
        </p>
        <p class="hint">{t('landing.offline')}</p>
        {!signedIn && <AccountLine />}
      </section>
      <Footer />
    </main>
  );
}
